import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * The human name of the entity currently open (event / session / form). The
 * breadcrumb shows it in place of the opaque id segment so users can see exactly
 * what they're looking at.
 */
export const breadcrumbEntityAtom = atom(null as string | null);

/**
 * Register the current page's entity name so the breadcrumb can display it.
 * Pass the name once it's loaded; it clears automatically on unmount so it never
 * leaks onto the next page.
 */
export const useBreadcrumbEntity = (name?: string | null) => {
  const [, setEntity] = useAtom(breadcrumbEntityAtom);

  useEffect(() => {
    const clean = name?.trim();
    setEntity(clean ? clean : null);
    return () => setEntity(null);
  }, [name, setEntity]);
};
